module.exports = __webpack_public_path__ + "img/screen-img-02.afa5676e.jpeg";